import { createFileRoute } from '@tanstack/react-router';

import { Page } from '@/components/layout/Page';
import { PageHeader } from '@/components/composed/PageHeader';
import { RouteError } from '@/components/composed/RouteError';
import { NotFound } from '@/components/composed/NotFound';
import { useDocumentTitle } from '@/lib/hooks/useDocumentTitle';
import { userId } from '@/lib/api/ids';
import { useSession } from '@/lib/session/useSession';
import { NotificationPreferences } from '@/features/portal';

/*
 * Portal notifications & settings (F02 R25/R26/R35, AC-c4ed6685). The way IN
 * from the portal nav to the client user's own four notification choices. A
 * Client Billing Contact reaches this screen from the portal sidebar
 * ('Notifications & Settings', now live — see portal-nav-items.ts).
 *
 * Thin route: it reads the current user from /me (the query layer, the one
 * identity source) and brands the id to UserId at this route boundary (ids are
 * branded only at creation boundaries — a route is one), then composes the
 * feature's own preferences surface. Identity is never read from anything typed
 * at sign-in (service-context).
 */
export const Route = createFileRoute('/_portal/portal/notifications')({
  component: PortalNotificationsPage,
  errorComponent: RouteError,
  notFoundComponent: NotFound,
});

function PortalNotificationsPage() {
  useDocumentTitle('Notifications & Settings');
  const { session } = useSession();
  return (
    <Page>
      <PageHeader title="Notifications & Settings" />
      {session ? <NotificationPreferences userId={userId(session.id)} /> : null}
    </Page>
  );
}
